export const MessageType = {
    "conversation": "conversation",
    "senderKeyDistributionMessage": "senderKeyDistributionMessage",
    "imageMessage": "imageMessage",
    "contactMessage": "contactMessage",
    "locationMessage": "locationMessage",
    "extendedTextMessage": "extendedTextMessage",
    "documentMessage": "documentMessage",
    "audioMessage": "audioMessage",
    "videoMessage": "videoMessage",
    "call": "call",
    "chat": "chat",
    "protocolMessage": "protocolMessage",
    "contactsArrayMessage": "contactsArrayMessage",
    "highlyStructuredMessage": "highlyStructuredMessage",
    "fastRatchetKeySenderKeyDistributionMessage": "fastRatchetKeySenderKeyDistributionMessage",
    "sendPaymentMessage": "sendPaymentMessage",
    "liveLocationMessage": "liveLocationMessage",
    "requestPaymentMessage": "requestPaymentMessage",
    "declinePaymentRequestMessage": "declinePaymentRequestMessage",
    "cancelPaymentRequestMessage": "cancelPaymentRequestMessage",
    "templateMessage": "templateMessage",
    "stickerMessage": "stickerMessage",
    "groupInviteMessage": "groupInviteMessage",
    "templateButtonReplyMessage": "templateButtonReplyMessage",
    "productMessage": "productMessage",
    "deviceSentMessage": "deviceSentMessage",
    "messageContextInfo": "messageContextInfo",
    "listMessage": "listMessage",
    "viewOnceMessage": "viewOnceMessage",
    "orderMessage": "orderMessage",
    "listResponseMessage": "listResponseMessage",
    "ephemeralMessage": "ephemeralMessage",
    "invoiceMessage": "invoiceMessage",
    "buttonsMessage": "buttonsMessage",
    "buttonsResponseMessage": "buttonsResponseMessage",
    "paymentInviteMessage": "paymentInviteMessage",
    "interactiveMessage": "interactiveMessage",
    "reactionMessage": "reactionMessage",
    "stickerSyncRmrMessage": "stickerSyncRmrMessage",
    "interactiveResponseMessage": "interactiveResponseMessage",
    "pollCreationMessage": "pollCreationMessage",
    "pollUpdateMessage": "pollUpdateMessage",
    "keepInChatMessage": "keepInChatMessage",
    "documentWithCaptionMessage": "documentWithCaptionMessage",
    "requestPhoneNumberMessage": "requestPhoneNumberMessage",
    "viewOnceMessageV2": "viewOnceMessageV2",
    "encReactionMessage": "encReactionMessage",
    "editedMessage": "editedMessage",
    "viewOnceMessageV2Extension": "viewOnceMessageV2Extension",
    "pollCreationMessageV2": "pollCreationMessageV2",
    "scheduledCallCreationMessage": "scheduledCallCreationMessage",
    "groupMentionedMessage": "groupMentionedMessage",
    "pinInChatMessage": "pinInChatMessage",
    "pollCreationMessageV3": "pollCreationMessageV3",
    "scheduledCallEditMessage": "scheduledCallEditMessage",
    "ptvMessage": "ptvMessage",
    "botInvokeMessage": "botInvokeMessage"
}